/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { HtmlSanitizer } from 'roosterjs';

import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { useClientContext } from '@bingads-webui-campaign-react/smart-page-context';
import { withErrorView } from '@bingads-webui-campaign-react/smart-page-error-boundary';

import { dataProperties } from './data-config';

const getStyles = (components = {}, { palette = {} }) => {
  const container = {
    ...components.section,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  };
  const businessSummary = {
    fontSize: 18,
    lineHeight: '28px',
    color: palette.secondaryText,
    margin: '24px 50px 25px 50px',
  };

  return {
    container,
    mobileContainer: {
      ...container,
      marginLeft: 0,
      marginRight: 0,
    },
    aboutUs: {
      ...components.truncate,
      ...components.sectionTitle,
      padding: '0 20px',
      display: 'block',
      textAlign: 'center',
    },
    businessSummaryContainer: {
      display: 'flex',
      alignItems: 'center',
      maxWidth: 900,
      wordBreak: 'break-word',
      backgroundColor: palette.secondaryBackground,
    },
    businessSummary,
    mobileBusinessSummary: {
      ...businessSummary,
      margin: '24px 23px 24px 23px',
      textAlign: 'left',
    },
  };
};

export const UnStyledSmartSummaryView = ({
  classes,
  aboutUs,
  summary,
  id,
}) => {
  const { isMobile } = useClientContext();

  const summaryHtmlContent = HtmlSanitizer.sanitizeHtml(HtmlSanitizer.convertInlineCss(summary));

  return (
    <div
      className={isMobile ? classes.mobileContainer : classes.container}
      id={id}
    >
      <h1 className={classes.aboutUs} data-property={dataProperties.aboutUs}>
        {aboutUs}
      </h1>
      <div
        className={classes.businessSummaryContainer}
        data-property={dataProperties.businessSummary}
      >
        <div className={isMobile ? classes.mobileBusinessSummary : classes.businessSummary}>
          <div dangerouslySetInnerHTML={{ __html: summaryHtmlContent }} />
        </div>
      </div>
    </div>
  );
};

UnStyledSmartSummaryView.propTypes = {
  classes: PropTypes.shape({
    container: PropTypes.string.isRequired,
  }).isRequired,
  id: PropTypes.string.isRequired,
  aboutUs: PropTypes.string.isRequired,
  summary: PropTypes.string.isRequired,
};

export const SmartSummaryView = withErrorView(withDefaultStyles(
  UnStyledSmartSummaryView,
  getStyles
), 'componentMode');
